export default __webpack_public_path__ + "static/media/home.55271d69.jpg";